import { useIsDesktop } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ValuationNotFound } from '../../components/OpenDataPaymentForm';
import { selectCheckEstimationExists } from '../../selectors/checkEstimationExists/selectCheckEstimationExists';

export const ValuationNotFoundContainer: React.VFC = () => {
  const isDesktop = useIsDesktop();
  const { isNotFound } = useSelector(selectCheckEstimationExists);

  if (isNotFound) {
    return <ValuationNotFound isDesktop={isDesktop} />;
  }

  return null;
};
